export default "__VITE_ASSET__0QhInW4U__"